import { observer } from 'mobx-react';

const AgentSideBarShowMoreButton = observer(
  ({ onClick = () => {}, isActive = false }) => {
    const className = isActive
      ? 'agent-sidebar-show-more-button active'
      : 'agent-sidebar-show-more-button';

    return (
      <button
        className={className}
        onClick={onClick}
      >
        All conversations
      </button>
    );
  }
);

export default AgentSideBarShowMoreButton;